// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__3wQZ7","footer":"ModalInfo_footer__2pzUO"};